import React from "react";

export const Th = ({ children }) => (
    <th className="text-left p-3 font-bold">{children}</th>
);

export const Td = ({ children, className = "" }) => (
    <td className={`p-3 ${className}`}>{children}</td>
);

export function Tile({ label, value }) {
    return (
        <div className="bg-[#09090b] p-5">
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold mb-1">{label}</div>
            <div className="font-display text-4xl text-orange-500 leading-none">{value}</div>
        </div>
    );
}
